import { useContext } from 'react';
import { Box, Chip } from '@mui/material';
import FaceIcon from '@mui/icons-material/Face';
import { useTranslation } from 'react-i18next';
import { AppContext, SttTable } from '../../sporttia/all';
import { fullName } from '../../lib/utils';
import DateBuilder from '../../lib/DateBuilder';
import type { Payment } from '../../types/models/Payment';

interface PaymentChild {
    id: number;
    created: string;
    concept: string;
    ini?: string;
    end?: string;
    user?: {
        id: number;
        mship?: {
            id: number;
            name: string;
            fullName: string;
        };
    };
    name?: string;
    paymentForm: string;
    paymentDate: string;
    price: number;
}

interface PaymentModalChildrenProps {
    payment: Payment & {
        children?: PaymentChild[];
    };
    onOpenChild?: (child: { id: number }) => void;
}

export default function PaymentModalChildren({
    payment,
    onOpenChild,
}: PaymentModalChildrenProps) {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();

    return (
        <Box>
            {payment.children && (
                <SttTable
                    data={payment.children}
                    onClickRow={
                        onOpenChild
                            ? (row: PaymentChild) => onOpenChild({ id: row.id })
                            : undefined
                    }
                    columns={[
                        {
                            field: 'created',
                            title: t('Created'),
                            value: (row: PaymentChild) =>
                                new DateBuilder(
                                    row.created,
                                    cxt?.sc?.timezone?.name,
                                    cxt?.lang?.key,
                                ).dmy(),
                        },
                        // {field:'creator', title:t('Creator'), type:'user.login'},
                        // {field:'module', title:t('Module'), type:'module'},
                        {
                            field: 'concept',
                            title: t('Concept'),
                            type: 'link',
                            align: 'left',
                            value: (r: PaymentChild) => (
                                <>
                                    {r.concept}
                                    {r.user && (
                                        <Box mt={1}>
                                            <Chip
                                                size="small"
                                                icon={<FaceIcon />}
                                                label={
                                                    r.user?.mship
                                                        ? fullName(
                                                              r.user?.mship,
                                                          )
                                                        : r.name
                                                }
                                            />
                                        </Box>
                                    )}
                                </>
                            ),
                        },
                        // {field:'period', title:t('Period'), value:r => ({ini:r.ini, end:r.end}), type:'period'},
                        // {field:'collector', title:t('Collector'), type:'user.login'},
                        {
                            field: 'paymentForm',
                            title: t('PForm'),
                            type: 'pf',
                        },
                        {
                            field: 'paymentDate',
                            title: t('Paid'),
                            type: 'dmy',
                        },
                        {
                            field: 'price',
                            title: t('Price'),
                            type: 'price',
                        },
                    ]}
                    // onFetch={loadPayments}
                />
            )}
        </Box>
    );
}
